import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const EMTIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });
  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescEMT">Emergency Medical Symbol</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="M114.4 45.5H87a2.1 2.1 0 0 0-2.1 2.1V73l-22-12.7a2.1 2.1 0 0 0-1-.2 2 2 0 0 0-.6 0 2.1 2.1 0 0 0-1.3 1L46.2 85a2.1 2.1 0 0 0 .8 2.9l22 12.7-22 12.7a2.1 2.1 0 0 0-.8 3L60 139.8a2.1 2.1 0 0 0 1.2 1 2 2 0 0 0 .6 0 2.2 2.2 0 0 0 1-.2l22-12.7v25.4a2.1 2.1 0 0 0 2.2 2.1h27.5a2.1 2.1 0 0 0 2-2.1V128l22 12.7a2.2 2.2 0 0 0 1.7.2 2.1 2.1 0 0 0 1.3-1l13.7-23.8a2.1 2.1 0 0 0-.8-2.8l-22-12.8 22-12.7a2.1 2.1 0 0 0 .8-2.9l-13.8-23.8a2.1 2.1 0 0 0-1.8-1 2.1 2.1 0 0 0-1 .2l-22 12.7V47.6a2.1 2.1 0 0 0-2.2-2.1z"
        className="accent"
      />
      <path
        d="m113.1 73-3.8-2.7c-.8-.5-1.8-.6-1.2-.6h-6.6v-2.8a4.3 4.3 0 1 0-3.6-.1v3a16.1 16.1 0 0 0-5.4 2.2 9.4 9.4 0 0 0-3.6 5.7 10.3 10.3 0 0 0 .8 5.6c1 1.7 1.8 2.9 6 4.9l2.3 1 .1 11.6a10.9 10.9 0 0 0-4.3 3.5 6.8 6.8 0 0 0-1.6 5.4c.1 1.6 1 4.4 3 5.5a24.8 24.8 0 0 0 3 1.3v8.1a6.9 6.9 0 0 0-3 2.6c-1.2 2.3-.8 4 .3 5.3a12 12 0 0 0 2.9 2v8a12.6 12.6 0 0 1-2.2.7s-.3.4.1.5a6.6 6.6 0 0 0 2.1-.3v3.7c0 1 .5 2.4 1.3 2.4.7 0 1.1-1.4 1.1-2.4v-4.7l.2-.1c1.5-1 2.8-2.2 3-4.1a3 3 0 0 0-1.5-3.2l-1.5-1v-8l.6-.3c2.2-1.2 3.4-1.9 4.2-3.6a5.7 5.7 0 0 0 .1-4.6 7 7 0 0 0-4-3.5l-.7-.3V104a25.6 25.6 0 0 0 6.3-4.3c2.7-3 1.5-8 .6-9.7s-2.6-3.7-6.2-5.1l-.5-.2V73.2h1.8s1.2 2.4 5 2.8 4.7 0 4.7 0l1.1-1.7s0-.4-.9-1.2z"
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
      />
      <path
        d="M101.2 136a2.1 2.1 0 0 0-.2-.1v5a6 6 0 0 0 1.2-1.5 2.5 2.5 0 0 0-1-3.3zm-4.2-7c-.5 1.4.3 2 1 3a2.4 2.4 0 0 0 .3.2v-4.7a2.9 2.9 0 0 0-1.3 1.4zm4.1-11.4v5.4a4.7 4.7 0 0 0 .6-.5c1.8-1.7 1.3-3.4.3-4.4a3.3 3.3 0 0 0-.9-.5zm-2.9-5v-6.8c-2.4 1.5-1.8 4.6-1 5.7a3 3 0 0 0 1 1zm5-20a7.2 7.2 0 0 0-1.9-1.7v8a12.6 12.6 0 0 0 1.8-2 3.4 3.4 0 0 0 .1-4.3zM98 73.7a6.9 6.9 0 0 0-3.2 2.2 5.3 5.3 0 0 0-.3 5c.5.9 1.8 1.6 3.6 2.4z"
        className="accent"
      />
    </Icon>
  );
};

export default EMTIcon;
